var $6fa8837a63df4f12$exports = {};
$6fa8837a63df4f12$exports = {
    "collectionLabel": `Ieteikumi`
};


export {$6fa8837a63df4f12$exports as default};
//# sourceMappingURL=lv-LV.mjs.map
